import PropTypes from "prop-types";
// material
import { Box } from "@mui/material";
import { Routes } from "../constant/api_url";

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object
};

export default function Logo({ sx }) {
  return (
    <Box
      component="img"
      // src="/static/LVB-Logo.png"
      src={Routes.API_HOSTNAME + "logo/LVB-PRIME-LOGO.png"}
      onError={(e) => {
        e.target.onerror = null;
        e.target.src = "/static/logo/LVB-PRIME-LOGO.png";
      }}
      sx={{ width: "100%", objectFit: "contain", ...sx }}
    />
  );
}
